import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/baseUi/dialog"
import { Text } from "@/components/ui/baseUi/text"
import { word } from "@modules/core/utils/i18n"
import { useState } from "react"

export function AppShutdownModal() {
  const [open, setOpen] = useState(true)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>
            <Text fontStyle="TL" className="text-center">
              {word("shutdown.title")}
            </Text>
          </DialogTitle>
          <DialogDescription>
            <Text fontStyle="BM" className="whitespace-pre-line">
              {word("shutdown.message")}
            </Text>
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  )
}
